"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var gateway_client_key_serialiser_1 = require("./../services/gateway-control/gateway-client-key-serialiser");
var gateway_client_list_serialiser_1 = require("./../services/gateway-control/gateway-client-list-serialiser");
var gateway_client_request_serialiser_1 = require("./../services/gateway-control/gateway-client-request-serialiser");
var gateway_response_serialiser_1 = require("./../services/gateway-control/gateway-response-serialiser");
var service_definition_1 = require("./../services/service-definition");
exports.GATEWAY_CLIENT_REQUEST = {
    id: 170,
    request: gateway_client_request_serialiser_1.GatewayClientRequestSerialiser,
    response: gateway_response_serialiser_1.GatewayResponseSerialiser
};
exports.REGISTER_GATEWAY_CLIENT = {
    id: 173,
    request: gateway_client_key_serialiser_1.GatewayClientKeySerialiser,
    response: service_definition_1.NullSerialiser
};
exports.REMOVE_GATEWAY_CLIENT = {
    id: 174,
    request: gateway_client_key_serialiser_1.GatewayClientKeySerialiser,
    response: service_definition_1.NullSerialiser
};
exports.GET_GATEWAY_CLIENTS = {
    id: 175,
    request: service_definition_1.NullSerialiser,
    response: gateway_client_list_serialiser_1.GatewayClientListSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-services.js
// module id = 1582
// module chunks = 1